import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc: string;
  icon?: string;
  action?: ReactNode;
  light?: boolean;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  icon = "ri-fire-line",
  action,
  light = false,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span
          className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-label font-medium tracking-widest ${
            light
              ? "bg-background-50/10 text-accent-400"
              : "bg-primary-100/70 text-primary-700"
          }`}
        >
          <i className={`${icon} text-sm`} />
          {eyebrow}
        </span>
        <h3
          className={`mt-3.5 font-heading text-2xl font-bold leading-snug md:text-[30px] ${
            light ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h3>
        <p className={`mt-3 text-sm leading-relaxed md:text-[15px] ${light ? "text-background-200" : "text-foreground-600"}`}>
          {desc}
        </p>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}